<template>
  <div class="mb-8">
    <h1 class="mb-2 pb-1 text-l text-gray-900">
      {{ title }}
    </h1>
    <p v-if="hasSlot" class="mb-2 text-gray-900">
      <slot />
    </p>
    <ul class="List">
      <li v-if="icon">
        <span v-if="selectText">Select text, then click</span>
        <span v-else>Click</span>
        <lm-icon size="20" :icon="icon" class="mx-1" />in the formatting toolbar
      </li>
      <li v-if="shortcut">
        Select text, then press<shortcut :text="`Cmd/Ctrl+${shortcut}`" />
      </li>
      <li v-if="uniqueShortcut">Press <shortcut :text="uniqueShortcut" /></li>
      <li v-if="extra">{{ extra }}</li>
    </ul>
  </div>
</template>

<script type="text/babel">
import Shortcut from '@/components/modals/editorHelp/Shortcut'
import LmIcon from '@/components/ui/LmIcon'
export default {
  name: 'HelpBlock',
  components: {Shortcut, LmIcon},
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      default: null
    },
    icon: {
      type: String,
      default: null
    },
    selectText: {
      type: Boolean,
      default: true
    },
    shortcut: {
      type: String,
      default: null
    },
    uniqueShortcut: {
      type: String,
      default: null
    },
    extra: {
      type: String,
      default: null
    }
  },
  computed: {
    hasSlot() {
      return !!this.$slots.default
    }
  }
}
</script>

<style scoped>
.List {
  @apply mb-10 pl-5 list-disc leading-normal;
}
.List li {
  margin-bottom: 6px;
}
</style>
